/**
 * @brisa/ui · UserTypeCard
 *
 * Card grande clicável (≥120px) para escolha de identidade (visitor/resident).
 * D2 (UI_SPEC): card NÃO selecionado NÃO fica dim — permanece clicável.
 */
import * as React from 'react';

export interface UserTypeCardProps {
  value: 'visitor' | 'resident';
  selected: boolean;
  label: string;
  microcopy?: string;
  onSelect: (value: 'visitor' | 'resident') => void;
  dataEvent?: string;
}

export function UserTypeCard({
  value,
  selected,
  label,
  microcopy,
  onSelect,
  dataEvent = 'onboarding-step-selecting',
}: UserTypeCardProps) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      onClick={() => onSelect(value)}
      data-event={dataEvent}
      data-step="1"
      data-value={value}
      className="brisa-user-type-card"
      data-selected={selected ? 'true' : 'false'}
    >
      <span className="brisa-display brisa-user-type-card__label">{label}</span>
      {microcopy && <span className="brisa-user-type-card__microcopy">{microcopy}</span>}
      {selected && (
        <span className="brisa-user-type-card__check" aria-hidden="true">
          <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
            <path
              d="m2.5 6 2.5 2.5L9.5 3.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        </span>
      )}
    </button>
  );
}
